import { render, staticRenderFns } from "./CustomModal.vue?vue&type=template&id=101a37d7&scoped=true"
import script from "./CustomModal.vue?vue&type=script&lang=js"
export * from "./CustomModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101a37d7",
  null
  
)

export default component.exports